<template>
  <article class="mb-6 bg-brand-light text-brand-dark p-8 rounded-2xl tablet:mb-0 h-full">
    <header class="mb-3">
      <h3 class="article-title mb-3 block">
        {{ title }}
      </h3>
      <dl class="grid grid-cols-2 gap-x-2 opacity-66 text-sm items-center justify-center">
        <template v-if="duration">
          <dt class="text-end">
            {{ t('service.duration') }}
          </dt>
          <dd class="text-start">
            {{ duration }}
          </dd>
        </template>

        <template v-if="price">
          <dt class="text-end">
            {{ t('service.price') }}
          </dt>
          <dd class="text-start">
            {{ price }}
          </dd>
        </template>
      </dl>
    </header>
    <div>
      <p v-if="summary">{{ summary }}</p>
      <slot name="summary"/>
    </div>
  </article>
</template>

<script lang="ts" setup>
const {
    title,
    summary = '',
    price = '',
    duration = '',
} = defineProps<{
    title: string,
    summary?: string,
    duration?: string,
    price?: string,
}>();

const { t } = useI18n();
</script>